export var getLabelAndValueString = function getLabelAndValueString(label, value) {
  return "".concat(label, ": ").concat(value);
};